export const HEADER_CLIENT_RELEASE = "X-IF-CLIENT-RELEASE";
